import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Button, DashboardModuleListItem, DashboardModule, Text,
} from '@domain-group/suit-theme'

import { isValidPrice } from '@domain-group/javascript-utils'

import useAgency from '@hooks/useAgency'
import useBillingType from '@hooks/useBillingType'
import useFlipperKey from '@hooks/useFlipperKey'

import type { AgencyModel } from '@models/types'

import ZuoraSubscriptionStatus from './components/ZuoraSubscriptionStatus'

interface SubscriptionProps {
  agencyPayload: ReturnType<typeof useAgency>,
}

const Subscription = (props: SubscriptionProps) => {
  const { agencyPayload } = props
  const {
    agency,
    callbacks: { manageAgencySubscription },
    loading,
  } = agencyPayload

  const {
    billing_type_id,
    subscription_fee,
    subscription_user_limit,
    zuora_account_number,
    zuora_charge_number,
    zuora_subscription_number,
  } = agency as AgencyModel

  const billingTypePayload = useBillingType({ id: billing_type_id })
  const { billingType: { title: billingTypeTitle }, loading: loadingBillingType } = billingTypePayload

  const { isEnabled } = useFlipperKey('broadcast_to_zuora')

  const hasSubscription = isEnabled
    ? isValidPrice(subscription_fee!) && !!billing_type_id
    : isValidPrice(subscription_fee!)

  const userLimitText = isValidPrice(subscription_user_limit!) ? `${subscription_user_limit} Users` : 'Unlimited Users'

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} loading={loading} title="Subscription">
      {!loading && hasSubscription && (
        <DashboardModuleListItem
          isChecked={hasSubscription}
          onClick={() => manageAgencySubscription()}
          secondaryText={
            hasSubscription && !loadingBillingType
              ? <Text style={{ textTransform: 'capitalize' }}>{billingTypeTitle}</Text>
              : null
          }
          showCheckbox
          title={hasSubscription ? `$${subscription_fee}` : 'Subscription Not Set'}
        >
          {hasSubscription && (
            // @ts-expect-error TS2339
            <DashboardModuleListItem.TertiaryText>{userLimitText}</DashboardModuleListItem.TertiaryText>
          )}
        </DashboardModuleListItem>
      )}

      {!loading && (
        <>
          {billing_type_id && (
            <DashboardModule.Footer boxProps={{ borderTop: 'none' }}>
              <ZuoraSubscriptionStatus
                isSynced={!!zuora_subscription_number && !!zuora_charge_number}
              />
            </DashboardModule.Footer>
          )}

          {!hasSubscription && (
            <DashboardModule.Footer boxProps={{ borderTop: 'none' }}>
              <Text
                color="bodyFontLightColor"
                display={['none', 'flex']}
                fontSize="small"
                maxWidth="60%"
                variant="ellipsis"
              >
                Subscription Not Set
              </Text>

              <DashboardModule.FooterRight>
                <Button
                  buttonStyle="secondaryEdit"
                  icon={<FontAwesomeIcon icon={faPlus} />}
                  onClick={() => manageAgencySubscription()}
                  // @ts-expect-error TS2322
                  size={['medium', 'small']}
                  width={['100%', 'fit-content']}
                >
                  Add Subscription
                </Button>
              </DashboardModule.FooterRight>
            </DashboardModule.Footer>
          )}
        </>
      )}
    </DashboardModule>
  )
}

export default Subscription
